import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { S, formatCHF } from '../regureStyles';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const GenerateCommissionsDialog = ({ periodOptions, defaultPeriod, onClose, onGenerated }) => {
  const { t } = useTranslation();
  const [period, setPeriod] = useState(defaultPeriod);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const submit = async (force = false) => {
    setBusy(true);
    setError(null);
    try {
      const resp = await axios.post(
        `${BASE_URL}/commissions/generate`,
        { period, force: !!force },
        { withCredentials: true }
      );
      setResult(resp.data?.data);
      onGenerated && onGenerated();
    } catch (err) {
      setError(err?.response?.data?.message || err.message || t('screens.commissions.generate.failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,0.35)',
        zIndex: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 460,
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        <div style={{ fontSize: 16, fontWeight: 700, color: S.textPrimary }}>
          {t('screens.commissions.generate.title')}
        </div>

        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase' }}>
            {t('screens.commissions.generate.period')}
          </span>
          <select
            value={period}
            onChange={e => setPeriod(e.target.value)}
            style={{
              padding: '9px 12px',
              background: '#fff',
              border: `1px solid ${S.borderLight}`,
              borderRadius: 8,
              fontSize: 13,
              color: S.textPrimary,
              outline: 'none',
            }}
          >
            {periodOptions.map(p => (
              <option key={p.value} value={p.value}>{p.label}</option>
            ))}
          </select>
        </label>

        {result && (
          <div
            style={{
              padding: 12,
              borderRadius: 8,
              background: '#f0fdf4',
              border: '1px solid #bbf7d0',
              fontSize: 13,
              color: '#065f46',
            }}
          >
            {t('screens.commissions.generate.result', {
              records: result.commissionsGenerated || 0,
              policies: result.policiesProcessed || 0,
              total: formatCHF(result.totalAmount || 0),
            })}
            {typeof result.existingBefore === 'number' && result.existingBefore > 0 && (
              <div style={{ marginTop: 6, fontSize: 12, color: '#047857' }}>
                {t('screens.commissions.generate.existing', { count: result.existingBefore })}
              </div>
            )}
          </div>
        )}

        {error && (
          <div
            style={{
              padding: 12,
              borderRadius: 8,
              background: '#fef2f2',
              border: '1px solid #fecaca',
              fontSize: 13,
              color: '#991b1b',
            }}
          >
            {error}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            onClick={onClose}
            style={{
              padding: '9px 14px',
              background: '#fff',
              color: S.textSecondary,
              border: `1px solid ${S.borderLight}`,
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {t('screens.commissions.generate.close')}
          </button>
          <button
            onClick={() => submit(false)}
            disabled={busy}
            style={{
              padding: '9px 14px',
              background: S.burgundy,
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: busy ? 'wait' : 'pointer',
              opacity: busy ? 0.7 : 1,
            }}
          >
            {busy ? '…' : t('screens.commissions.generate.generateNow')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GenerateCommissionsDialog;
